//@ts-ignore
import 'react-form-builder2/dist/app.css';
import React, { useContext, useEffect, useRef, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addMessage } from "Redux/messageReducer";
import { RootState } from "store";
/***********************************
 ****** COMPONENT FOR ROUTING ******
 ***********************************/
// Added indexes to directories and now ./Pages export all pages in its directories
import {
  // Password, // to see if we have to have a page with reset password form
  Welcome,
  ForgotPassword,
  Dashboard,
  Process,
  NewProcessModel,
} from "./Component/Pages";
import {
  Login,
  Organizations,
  MyActivities,
  Notifications,
  NotFound,
  Processes,
  Password,
  Registration,
  // Email,
  Organization,
  Invitation,
  ExternalInvitation,
  Statistics,
  Robots,
  RobotsHelp,
  // PrivacyAndPolicy,
  Scheduled,
  FormBuilderPage,
  // Scheduled,
} from "pages";
import SnackbarModel from "model/snackbarModel";
import { Stack } from "@mui/material";
import Message from "./components/Message";
import { noTokenApi } from "api";
import { AuthContext, NotificationContext, UtilityContext } from "contexts";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Profile from "pages/Profile";
import { CONSTANTS } from "common";
import { useSSE, useVersions } from "hooks";
import { trackPageView } from "common/utilities";
import Billing from 'components/dialogs/Billing';
import Support from 'pages/Support';
import { Notification } from "model/notificationsModel";
import NotificationsSettings from 'components/NotificationsSettings';
import FlowentiLoader from 'components/FlowentiLoader';
import ForgotPasswordConfirm from 'Component/Pages/ForgotPassword/ForgotPasswordConfirm';
import LandingPage from 'pages/LandingPage';
import RoiPage from 'pages/roi/RoiPage';
import VersionChip from 'components/aiChat/VersionChip';

function App() {
  const dispatch = useDispatch();
  const [translationsLoading, setTranslationsLoading] = useState(false)
  const loadingCount = useRef(0)
  const {
    actions: { removeOrganizationsFirstSearch },
  } = useContext(UtilityContext);
  const {
    state: { checkInApp, user },
    actions: { setUserAndJwt },
  } = useContext(AuthContext);
  const {
    actions: { setNotificationList },
  } = useContext(NotificationContext);
  const snackbars: Array<SnackbarModel> = useSelector(
    (state: RootState) => state.snackbar
  );
  const { getVersion, updateVersion } = useVersions();
  const [lastVersion, setLastVersion] = useState(
    process.env.REACT_APP_VERSION || ""
  );
  useSSE<{ messages: Notification[] }>(`notifications/sse`, ({ messages }) => setNotificationList({ notifications: messages }), true);
  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    const wsUrl = ["development", "test"].includes(process.env.REACT_APP_ENV || "") ? `${process.env.REACT_APP_STATS_BACKEND_BASE_URI}/version` : `${process.env.REACT_APP_WEBSOCKET_PROTOCOL}://${location.host}${process.env.REACT_APP_STATS_BACKEND_BASE_URI}/version`;
    const ws = new WebSocket(wsUrl)
    ws.onopen = () => {
      ws.onmessage = ({ data: version }) => {
        if (version !== lastVersion) {
          setLastVersion(version);
        }
      };
    };
    return () => {
      ws.close();
    };
  }, [lastVersion]);

  const _location = useLocation();

  useEffect(() => {
    trackPageView(_location.pathname + _location.search);
  }, [_location]);

  useEffect(() => {
    const loggedUser = JSON.parse(
      localStorage.getItem(CONSTANTS.STORE_USER) || "null"
    );
    if (loggedUser) {
      setUserAndJwt(loggedUser);
    } else {
      setUserAndJwt(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (checkInApp) {
      (async () => {
        const lang = user?.i18n || navigator.language.split("-")[0];
        setTranslationsLoading(true)
        const startTime = new Date()
        const result = await noTokenApi.get(`messages/${lang}`);
        document.documentElement.setAttribute("lang", lang);
        dispatch(addMessage(result.data.messages));
        if (loadingCount.current === 0) {
          const endTime = new Date()
          setTimeout(() => { setTranslationsLoading(false) }, 1000 - (endTime.getTime() - startTime.getTime()))
        }
        else {
          setTranslationsLoading(false)
        }
        loadingCount.current += 1
      })();
    }
  }, [dispatch, user, checkInApp]);

  useEffect(() => {
    if (!user) {
      removeOrganizationsFirstSearch({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (translationsLoading) {
    return <FlowentiLoader />
  }

  return !checkInApp ? null : (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={user?.i18n || navigator.language.split("-")[0]}
    >
      <Stack
        id="message"
        spacing={2}
        sx={{
          zIndex: (_) => 9999999999999,
          position: "fixed",
          right: (_) => _.spacing(2),
          // iOS pushes the status bar / notch into the viewport when
          // viewport-fit=cover is set. Without this offset, snackbars
          // would render underneath the system bar on iPhone.
          top: (_) => `calc(${_.spacing(2)} + env(safe-area-inset-top, 0px))`,
          maxWidth: "50%",
        }}
      >
        {snackbars.map((_) => (
          <Message key={_.id} {..._} />
        ))}
      </Stack>
      <Routes>
        {/* <Route path="/privacy-policy" element={<PrivacyAndPolicy />} /> */}
        <Route path="/roi-calculator" element={<RoiPage />} />
        <Route path="/invitation" element={<Invitation />} />
        <Route path="/externalinvitation" element={<ExternalInvitation />} />
        {/* <Route path="support" element={<Support />} /> mi da problemi con il routing */}
        {!user && (
          <React.Fragment>
            <Route path="/" element={<LandingPage />} />
            {/* <Route path="/landing_it" element={<LandingPage />} /> */}
            <Route path="/login" element={<Login />} />
            <Route path="/forgotpassword_confirm" element={<ForgotPasswordConfirm />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/password" element={<Password />} />
            <Route path="/organization" element={<Organization />} />
            <Route path="/forgotpassword" element={<ForgotPassword />} />
            <Route path="/support" element={<Support />} />
            <Route path={`/billing`} element={<Billing />} />
          </React.Fragment>
        )}
        {/******************************
         ****** PROTECTED ROUTES ******
         ******************************/}
        <Route path="/dashboard/profile/support" element={<Support />} />
        <Route
          path="/dashboard"
          element={
            <Protected isLoggedIn={Boolean(user)}>
              <Dashboard newestVersion={lastVersion} getVersion={getVersion} />
            </Protected>
          }
        >
          <Route path="organizations" element={<Organizations />} />
          <Route path="processes" element={<Processes />} />
          <Route path="process-history" element={<Processes history />} />
          <Route path="schedules" element={<Scheduled />} />
          <Route path="myactivities" element={<MyActivities />} />
          <Route path="process" element={<Process />} />
          <Route path="process/insert" element={<NewProcessModel />} />
          <Route
            path="profile"
            element={<Profile updateVersion={updateVersion} />}
          />
          <Route
            path="/dashboard/process/edit/:editId/"
            element={<NewProcessModel />}
          />
          <Route path="statistics" element={<Statistics />} />
          <Route path="robots" element={<Robots />} />
          <Route path="robots/help" element={<RobotsHelp />} />
          <Route path="/dashboard/robots/:id/form-builder" element={<FormBuilderPage />} />
          <Route path="notifications/list" element={<Notifications />} />
          <Route path="notifications/settings" element={<NotificationsSettings />} />
          <Route path="*" element={<NotFound />} />
          <Route path={`organizations/:organizationId/billing`} element={<Billing />} />
        </Route>
        <Route
          path="*"
          element={<Navigate to="/dashboard/organizations" replace />}
        />
      </Routes>
      <VersionChip />
    </LocalizationProvider>
  );
}

interface ProtectedProps {
  isLoggedIn: boolean;
}
const Protected: React.FC<React.PropsWithChildren<ProtectedProps>> = ({
  isLoggedIn,
  children,
}) => {
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }
  return <React.Fragment>{children}</React.Fragment>;
};

export default App;
